import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { IOrcamento } from "app/types/IOrcamento";
import { ServicoAgregado, ServicoAgregadoEntity } from "app/types/ServicoAgregado";
import { tratamentoErroPadrao } from "app/use-cases";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react";
import { ModalServicosAgregados } from "./ModalServicosAgregados";
import { AdicionarServicosAgregados } from "app/use-cases/orcamento/AdicionarServicosAgregados";

export type AgregadosContainerProps = {
    item: IItemOrcamento,
    onFechar: (e: any) => void;
}

export const ModalServicosAgregadosContainer = (props: AgregadosContainerProps) => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);
 
    const [servicosAgregados, setServicosAgregados] = useState<ServicoAgregado>()
    const [processando, setProcessando] = useState(false);

    const onObterDadosServicosAgregados = async (numerodaPagina: number) => {
         
        try {
            globalMU.blockUI(); 
            const tamanhoPagina = 1000 // "onAdicionarServicosAgregados" com paginacao nao esta funcionando corretamente
            const resposta = await microuniversoApi.Orcamento.obterListaServicosAgregados(props.item.Codigo, props.item.PrecoProduto, tamanhoPagina, numerodaPagina);
            setServicosAgregados({
                ...resposta,
                Entities: (resposta?.Entities ?? []).map((servico: ServicoAgregadoEntity) => ({
                    CodigoProduto: servico.CodigoProduto,
                    DescricaoProduto: servico.DescricaoProduto,
                    CodigoServicoAgregado: servico.CodigoServicoAgregado,
                    DescricaoServicoAgregado: servico.DescricaoServicoAgregado,
                    ValorServico: servico.PercentualServico != null && servico.PercentualServico > 0 ? (servico.PercentualServico * props.item.PrecoProduto / 100) : servico.ValorServico,
                    TaxaISS: servico.TaxaISS,
                    PercentualServico: servico.PercentualServico != null && servico.PercentualServico > 0 ? servico.PercentualServico : (servico.ValorServico / props.item.PrecoProduto * 100),
                    EhPercentual: servico.PercentualServico != null && servico.PercentualServico > 0,
                    ServicoEmbutidoValorProduto: servico.ServicoEmbutidoValorProduto
                }))
            });
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }


    const onAdicionarServicosAgregados = async (IdentificadorItem: number, itensSelecionados: ServicoAgregadoEntity[]) => {
        try {
            setProcessando(true)

            if (itensSelecionados.length == 0) {
                globalMU.showErrorMessage("Por favor, selecione os servicos a serem adicionados.");
                return;
            }
            globalMU.blockUI();
            var result = await AdicionarServicosAgregados(
                orcamento.IdentificadorOrcamento, 
                itensSelecionados.map(item => (
                    { 
                        IdentificadorItem: IdentificadorItem,
                        CodProTextoPadrao: item.CodigoServicoAgregado,
                        DescricaoServico: item.DescricaoServicoAgregado,
                        OidFuncionarioExecutor: 7,
                        Valor: item.ValorServico,
                        EhPercentual: item.EhPercentual,
                        Percentual: item.PercentualServico ? item.PercentualServico : 0,
                        TaxaIss: item.TaxaISS,
                        ServicoEmbutidoValorProduto: item.ServicoEmbutidoValorProduto ? 1 : 0
                    }
                )));
                if (result.status == "SUCESSO") {
                    globalMU.showSuccessMessage("Serviços agregados adicionados com sucesso.");
                    props.onFechar(null);
                }

        } catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            setProcessando(false)
            globalMU.unblockUI()
        }
    }



    useEffect(() => {
        props.item != null && onObterDadosServicosAgregados(1)
    }, [])

    return (
        <>
            {(props.item != null && servicosAgregados != null) 
            && 
            <ModalServicosAgregados
                codigo={props.item.CodigoProdutoExibicao && props.item.CodigoProdutoExibicao.trimEnd() != "" ? props.item.CodigoProdutoExibicao.trimEnd() : props.item.CodigoProduto.trimEnd()}
                descricao={props.item.Descricao}
                dados={servicosAgregados}
                corSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
                textoSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
                identificadorItem={props.item.Identificador}
                precoProduto={props.item.PrecoProduto}
                processando={processando}
                onSalvar={onAdicionarServicosAgregados}
                onFecharModal={props.onFechar} 
                onObterListaServicosAgregadosPorPagina={onObterDadosServicosAgregados}            
                />
            }
        </>

    )
}